import { ReleaseNoteDocumentView } from 'bff';

const WORDS_PER_MINUTE = 200;

const textsOf = (value: unknown): string[] => {
  if (typeof value === 'string') return [value];
  if (Array.isArray(value)) return value.flatMap(textsOf);
  if (value && typeof value === 'object')
    return Object.values(value).flatMap(textsOf);

  return [];
};

// Every word the note shows, its sections' copy included, at a reading pace.
export const readingMinutes = (note: ReleaseNoteDocumentView) => {
  const words = textsOf([
    note.title,
    note.subtitle,
    note.items.map((item) => [
      item.title,
      item.summary,
      item.description,
      item.sections.map((section) => [section.title, section.content]),
    ]),
  ])
    .join(' ')
    .split(/\s+/)
    .filter(Boolean).length;

  return Math.max(1, Math.round(words / WORDS_PER_MINUTE));
};
